import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Zap, Gift, ArrowRight } from "lucide-react";

const OFFERS = [
  {
    id: "launch-50-off",
    icon: Zap,
    text: "Launch offer — 50% off for our first 50 customers",
    cta: "Claim now",
    path: "/pricing-info",
    testid: "launch-banner-offer-pricing",
  },
  {
    id: "free-demo-ad",
    icon: Gift,
    text: "Book a demo and get 1 free ad, on us",
    cta: "Book now",
    path: "/contact",
    testid: "launch-banner-offer-demo",
  },
];

const ROTATE_MS = 5000;

const LaunchOfferBanner = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    document.body.setAttribute("data-launch-banner", "on");
    return () => document.body.removeAttribute("data-launch-banner");
  }, []);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % OFFERS.length);
    }, ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  const offer = OFFERS[index];
  const Icon = offer.icon;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[60] h-10 flex items-center justify-center overflow-hidden"
      style={{
        background: "linear-gradient(90deg, #1A1A1A 0%, #2A1810 50%, #1A1A1A 100%)",
        borderBottom: "1px solid rgba(255,90,54,0.35)",
      }}
      data-testid="launch-offer-banner"
      role="region"
      aria-label="Launch offers"
    >
      <button
        onClick={() => navigate(offer.path)}
        className="group flex items-center gap-2 px-4 py-1 text-white transition-opacity duration-500"
        style={{ opacity: 1 }}
        key={offer.id}
        data-testid={offer.testid}
      >
        <Icon size={14} style={{ color: "#FF5A36" }} />
        <span className="text-xs md:text-sm font-medium tracking-tight">
          <span className="hidden sm:inline">{offer.text}</span>
          <span className="sm:hidden">
            {offer.id === "launch-50-off" ? "50% off — first 50 customers" : "Book a demo — 1 free ad"}
          </span>
        </span>
        <span
          className="hidden md:inline-flex items-center gap-1 text-xs font-semibold px-2 py-0.5 rounded-full transition-transform group-hover:translate-x-0.5"
          style={{ backgroundColor: "#FF5A36", color: "#fff" }}
        >
          {offer.cta}
          <ArrowRight size={11} />
        </span>
        <span
          className="md:hidden inline-flex items-center text-xs font-semibold"
          style={{ color: "#FF5A36" }}
        >
          <ArrowRight size={12} />
        </span>
      </button>

      {/* Rotation dots */}
      <div className="absolute right-3 top-1/2 -translate-y-1/2 hidden sm:flex items-center gap-1.5">
        {OFFERS.map((o, i) => (
          <button
            key={o.id}
            onClick={() => setIndex(i)}
            className="w-1.5 h-1.5 rounded-full transition-all"
            style={{
              backgroundColor: i === index ? "#FF5A36" : "rgba(255,255,255,0.3)",
              transform: i === index ? "scale(1.2)" : "scale(1)",
            }}
            aria-label={`Show offer ${i + 1}`}
            data-testid={`launch-banner-dot-${i}`}
          />
        ))}
      </div>
    </div>
  );
};

export default LaunchOfferBanner;
